import React from 'react';
import { Row } from '@tanstack/react-table';
import { FieldMappingTreeNode } from '../../../../../../utils/fieldMappingTreeBuilder';
import styles from './TreeFieldMappingsTable.module.sass';

export interface ExpandableCellProps {
  row: Row<FieldMappingTreeNode>;
  children: React.ReactNode;
}

/**
 * Custom expandable cell component styled to match Axiom's DataTable
 */
export const ExpandableCell: React.FC<ExpandableCellProps> = ({
  row,
  children,
}) => {
  const node = row.original;
  const indentLevel = node.level;
  const basePadding = 16; // Base left padding
  const indentPx = basePadding + indentLevel * 24; // 24px per level
  const isExpandable = row.getCanExpand();

  const handleCellClick = () => {
    if (isExpandable) {
      row.getToggleExpandedHandler()();
    }
  };

  return (
    <div
      className={`${styles.expandableCell} ${
        isExpandable ? styles.expandableCellClickable : ''
      }`}
      style={{ paddingLeft: `${indentPx}px` }}
      onClick={handleCellClick}
    >
      {/* Expand/collapse chevron indicator */}
      {isExpandable ? (
        <span className={styles.expandIcon}>
          {row.getIsExpanded() ? '▾' : '▸'}
        </span>
      ) : (
        <div className={styles.expandIconSpacer} />
      )}

      {/* Cell content */}
      <div className={styles.cellContent}>{children}</div>
    </div>
  );
};
